import React, { useContext } from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import { resetStore, useAppDisPatch } from '../../../../redux/store';
import { ACCOUNT, SIGNIN } from '../../../../routes/routeConstants';
import TranslatingContainer from '../../../TranslatingContainer/TranslatingContainer';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';
import PlainSuccessModal from '../../PlainSuccessModal';
import DeleteConfirmationForm from './DeleteConfirmationForm';
import DeleteReasonForm from './DeleteReasonForm';

const DeleteModal = () => {
  const dispatch = useAppDisPatch();
  const modalContext = useContext(ModalContext);
  const navigate = useNavigate();

  const successActionFn = () => {
    dispatch(resetStore());
    localStorage.removeItem('authData');
    modalContext?.setShowModal(false);
    navigate(`/${ACCOUNT}/${SIGNIN}`);
  };

  return (
    <Container>
      <ModalContainer
        label='Delete Account'
        description='Are you sure you want to delete your account? This will permanently erase your account?'
        successComponent={() => (
          <PlainSuccessModal
            successActionFn={successActionFn}
            successLabel='Thank you for your feedback'
            description={modalContext?.successDescription ?? ''}
            secondaryDescription={modalContext?.secondarySuccessDescription}
            btnLabel='Okay'
          />
        )}
        showSuccessComponent={modalContext?.showSuccessComponent}
      >
        <FormContainer>
          <TranslatingContainer>
            <DeleteReasonForm />
            <DeleteConfirmationForm />
          </TranslatingContainer>
        </FormContainer>
      </ModalContainer>
    </Container>
  );
};

export default DeleteModal;

const Container = styled.div`
  flex-direction: column;
  gap: 12px;
  display: flex;
`;

const FormContainer = styled.div`
  display: flex;
  overflow: hidden;

  @media (max-width: 884px) {
    width: 100%;
  }
`;
